import React, {useEffect} from "react";
import PullToRefresh from "react-simple-pull-to-refresh";
import {useNavigate, useNavigationType, useParams} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {
	fetchReceivableInfo, fetchVoucherInfo,
	updateReceivableInfo,
	updateReceivableInfoList
} from "redux/slices/sales/salesSlice";

import {getToday} from "utils/date";
import {getDetailTitle} from "utils/define";

import MainLayout from "layouts/MainLayout";
import SummaryInfo from "../period/SummaryInfo";
import DetailList from "./DetailList";
import BottomBranch from "components/ui/popup/BottomBranch";
import PullToRefreshing from "components/common/PullToRefreshing";



/**
 * [누적 미수금 조회]
 */

export const Detail = () => {
	const today = getToday();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const navigationType = useNavigationType();
	const {seqPartnerBranch} = useParams();

	let {
		searchPartner,
		searchBranch,
		searchDate,
		searchPeriodType,
		searchFilter,
		data,
		isLoading,
		isError
	} = useSelector(state => state.sales.receivableInfo);
	const partnerInfo = useSelector(state => state.partner);

	useEffect(() => {
		if(!searchPartner || (navigationType != "POP" && (searchPartner != partnerInfo.seqPartner || searchBranch != partnerInfo.seqPartnerBranch))) {
			searchPartner = partnerInfo.seqPartner;
			searchBranch = Number(seqPartnerBranch) || partnerInfo.seqPartnerBranch;
			dispatch(fetchReceivableInfo({
				searchPartner : searchPartner,
				searchBranch : searchBranch
			}));
		}
	}, []);

	useEffect(() => {
		const isUpdate = (
			!data || (
				searchPartner != data.searchInfo.searchPartner ||
				searchBranch != data.searchInfo.searchBranch ||
				today != data.searchInfo.searchDate
			)
		);
		if(isUpdate) eventHandler.update();
	}, [searchPartner, searchBranch]);

	const eventHandler = {
		update : () => {
			dispatch(updateReceivableInfo({
				searchPartner : searchPartner,
				searchBranch : searchBranch,
				searchDate : today
			}, fetchReceivableInfo));
		},
		changeBranch : (searchBranch) => {
			dispatch(fetchReceivableInfo({
				searchBranch : searchBranch
			}));
		},
		pullToRefresh: () => {
			return new Promise((resolve) => {
				setTimeout(() => {
					eventHandler.update();
					dispatch(updateReceivableInfoList(false));
					resolve();
				}, 700);
			});
		}
	};

	const render = () => {
		const title = getDetailTitle(partnerInfo, searchPartner, searchBranch, "누적 미수금");
		return (
			<PullToRefresh
				onRefresh={eventHandler.pullToRefresh}
				resistance={2}
				pullingContent={<></>}
				refreshingContent={<PullToRefreshing />}
			>
				<MainLayout
					withHeader={true}
					headerProps={{
						withBackButton : true,
						centerTitle : title
					}}
					backgroundColor="white"
					withBottomTab={false}
				>
					<SummaryInfo
						mode="receivable"
						title="현재까지 누적 미수금"
						data={{
							totalAmount : (data || {}).receivableAmount || 0
						}}
						color="red"
						isLoading={isLoading}
						isError={isError}
						onRefresh={eventHandler.update}
					/>
					<DetailList />
					<BottomBranch searchBranch={searchBranch} onChange={eventHandler.changeBranch} />
				</MainLayout>
    	</PullToRefresh>
		);
	};
	return render();
};

export default Detail;